import Web3 from 'web3';
import {  blockchainURL, username, password, contractAddress, contractAbi } from '../contracts/SupplyChainContract';

// Create an authenticated provider
const authProvider = new Web3.providers.HttpProvider(blockchainURL, {
  headers: [
    {
      name: 'Authorization',
      value: 'Basic ' + btoa(username + ':' + password)
    }
  ]
});

const web3 = new Web3(authProvider);
const SupplyChainContract = new web3.eth.Contract(contractAbi, contractAddress);

export const getBeefBatches = async () => {
  try {
    const currentBatchID = await SupplyChainContract.methods.currentBatchID().call();
    const totalBatches = currentBatchID - 1; // Total batches available
    const infectedBatchIDs = await SupplyChainContract.methods.getInfectedBatchIDs().call();

    console.log('Total Batches:', totalBatches);
    console.log('Infected Batches:', infectedBatchIDs);

    return { totalBatches, infectedBatchIDs };
  } catch (error) {
    console.error('Error fetching beef batches:', error);
    throw error;
  }
};